<app-navigation-header title="Learning Resources" i18n-title="@@learningTab-Learning Resources">
	<app-cards>
		<div class="content-container">
			<div class="border-bottom">
				<p
					class="learning-welcome"
					i18n="@@learningTab-welcomeWithTrademark"
					data-automation-id="learning-tab-welcome-with-trademark"
				>
					Welcome to the SentriKey® Access Training Hub, your resource for learning our key management solution. Explore
					our collection of video tutorials, guides, and best practices designed to help you efficiently navigate and
					utilize the app's features.
				</p>
				<p data-automation-id="learning-tab-only-in-english">
					<b i18n="@@learningTab-onlyInEnglish">All training materials and resources are provided in English only.</b>
				</p>
			</div>

			@for (section of sections; track section.automationId; let last = $last) {
				<div [class.border-bottom]="!last">
					<p class="learning-title" [attr.data-automation-id]="section.automationId">{{ section.title }}</p>
					<mat-list>
						@for (item of section.items; track item.automationId) {
							<mat-list-item [attr.data-automation-id]="item.automationId">
								<span class="doc-list-item" (click)="openLearningDoc(item)">{{ item.title }}</span>
							</mat-list-item>
						}
					</mat-list>
				</div>
			}
		</div>
	</app-cards>
</app-navigation-header>
